import { useState } from "react";
import { useCustomNavigation } from "@/hooks/useCustomNavigation";
import { db, collection, addDoc } from "../../Utils/firebase";
import { getHTMLString } from "../../Utils";
import "./ContactUs.scss";
import SuccessModal from "../../Components/Modal/SuccessModal";
import { useAuth } from "@/context/auth.context";

const ContactUs: React.FC = () => {
  const { user } = useAuth();
  const appVersion = process.env.REACT_APP_VERSION || "";

  const { navigateTo, navigateBack } = useCustomNavigation();
  const [subject, setSubject] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  const [email, setEmail] = useState<string>("");

  const [error, setError] = useState<string>("");
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
    navigateTo("/settings");
  };

  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async () => {
    if (!subject || !message || !email) {
      setError("Subject, message, and Email are required.");
      return;
    }

    if (!validateEmail(email)) {
      setError("Please enter a valid email address.");
      return;
    }

    if (subject.length > 50 || message.length > 500) {
      setError(
        "Subject must be 50 characters or less, and message must be 500 characters or less.",
      );
      return;
    }

    setIsSubmitting(true);
    setError("");

    try {
      const htmlContent = getHTMLString(
        subject,
        message,
        email,
        user && user.uid ? user?.uid : "",
        appVersion,
      );

      await addDoc(collection(db, "invitations"), {
        to: "hello@truetoform.fit",
        message: {
          subject: subject,
          html: htmlContent,
        },
        userEmail: email,
        name: "",
        userId: user?.uid,
      });
      setOpen(true);
    } catch (error) {
      setError(
        "An error occurred while sending your message. Please try again.",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={{ background: "var(--sm-bg, rgba(240, 242, 250, 1))" }} className="main-grid">
      <SuccessModal open={open} handleClose={handleClose} />
      <div className="contact-header-wrap">
        <div className="contact-header-container">
          <button onClick={navigateBack} className="cancel-button">
            Cancel
          </button>

          <h2>Contact Us</h2>
        </div>
      </div>
      <div className="contact-main-wrap">
        <div className="content">
          <div className="input-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {error && <p className="error-message">{error}</p>}
          </div>
          <div className="input-group">
            <label htmlFor="subject">
              Subject <span className="char-count">{subject.length}/50</span>
            </label>
            <input
              type="text"
              id="subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              maxLength={50}
            />
          </div>

          <div className="input-group">
            <label htmlFor="message">
              Message <span className="char-count">{message.length}/500</span>
            </label>
            <textarea
              id="message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              maxLength={500}
            />
          </div>
          <p className="response-info">
            Expect a response from TrueToForm in 1 - 2 business days. Any
            account inquiries will be addressed over email unless a phone number
            is specified.
          </p>
        </div>
      </div>

      <div className="contact-footer-container">
        <button
          onClick={() => {
            handleSubmit();
          }}
          className="send-button"
          disabled={!subject || !message || !email || isSubmitting}
        >
          Send
        </button>
      </div>
    </div>
  );
};

export default ContactUs;
